import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts';

export const StyledLabel = styled.label`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.REGULAR};
  color: ${({ hasError, isNegative }) =>
    hasError ? Color.RED : isNegative ? Color.WHITE : Color.CLOUD_BURST};
  margin-left: 8px;
  align-self: center;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  vertical-align: middle;
`;

export const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: inline-block;
  border: ${({ isNegative }) => (isNegative ? '0' : '2')}px solid
    ${({ checked }) => (checked ? Color.BLUE_DODGER : Color.MYSTIC)};
  width: 15px;
  min-width: 15px;
  height: 15px;
  background: ${props => (props.checked ? Color.BLUE_DODGER : Color.WHITE)};
  color: ${Color.WHITE};
  border-radius: 3px;
  transition: all 150ms;

  ${HiddenCheckbox}:disabled + & {
    background-color: ${Color.MYSTIC};
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 2px ${Color.CLOUD_BURST};
  }
`;
